//====================================================
//  Function: Benefits
//====================================================
function componentBenefits() {
  // FOOTER
  if ($("#footer").length == 0) {
    $(".overall-wrapper").append(
      '<div class="benefits-group"><div class="container"><div class="row"><div class="col-12"></div></div></div></div>'
    );
    $(".benefits-group .col-12").load("/ #benefits", function () {});
  }
}
